import type { View } from "../../../../../common/types.ts";
import useTitleBar from "../../hooks/useTitleBar.tsx";
import { formatPlayerNameFromLegacyName } from "../../util/playerNames.ts";
import PlayerMobile from "./PlayerMobile.tsx";

const Player = (props: View<"player">) => {
	useTitleBar({
		title: formatPlayerNameFromLegacyName(props.player.name),
		customMenu: props.customMenu,
	});

	return <PlayerMobile {...props} />;
};

export default Player;
